import { render, staticRenderFns } from "./carrierOrder.vue?vue&type=template&id=0bb5b5bc&scoped=true&"
import script from "./carrierOrder.vue?vue&type=script&lang=js&"
export * from "./carrierOrder.vue?vue&type=script&lang=js&"
import style0 from "./carrierOrder.vue?vue&type=style&index=0&id=0bb5b5bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb5b5bc",
  null
  
)

export default component.exports